import { useSelector } from 'react-redux';
import { analytics } from 'services/analytics';
import { AnalyticsEvent } from 'services/analytics/events';
import { RootState } from 'services/store';

const useAnalytics = () => {
  const subscriptionType = useSelector(
    (state: RootState) => state.user.subscriptionType
  );
  const hasDistribution = useSelector(
    (state: RootState) => state.user.hasDistribution
  );
  const track = (event: AnalyticsEvent) => {
    const analyticsEvent = {
      ...event,
      parameters: {
        ...event.parameters,
        subscriptionType,
        hasDistribution,
      },
    };

    analytics.track(analyticsEvent);
  };
  return { track };
};

export default useAnalytics;
